import { Component } from '@angular/core';

@Component({
  selector: 'app-lgpd',
  standalone: true,
  templateUrl: './lgpd.html',
  styleUrls: ['./lgpd.scss']
})
export class LgpdComponent {}
